'use client';
import React, { useState, useEffect, useCallback } from 'react';
import ProductsFilterBar from './ProductsFilterBar';
import ProductsGrid from './ProductsGrid';
import { AboutSection } from '@/components/sections';
import AboutSectionCategories from './AboutSectionCategories';
import FAQSectionCategories from './FAQSectionCategories';
import { FAQSection } from '@/components/sections';
import { Manufacturer, ProductBase } from '@/types/product';
import { BreadcrumbMenu, MenuRoute } from '@/types/menu';
import CategoriesSidebar from './CategoriesSidebar';
import Pagination from '@/components/ui/Pagination';
import { PaginationInfo } from '@/types/pagination';
import { useSortOptions, useFilterOptions } from '@/hooks/useProductFilters';
interface ProductsPageContentProps {
  breadcrumbMenu: BreadcrumbMenu;
  className?: string;
  products?: ProductBase[];
  menuCategories?: MenuRoute[];
  paginationInfo?: PaginationInfo;
  manufacturers?: Manufacturer[];
  sortBy: string;
  selectedOptions: string[];
  selectedManufacturer: Manufacturer | null;
  priceRange: [number, number];
  categoryId?: number; // Nuevo prop para el ID de categoría
  handleSortChange: (sort: string) => void;
  handleOptionsChange: (options: string) => void;
  handleFilterChange: (manufacturer?: number, price_min?: number, price_max?: number) => void;
  handlePageChange: (page: number) => void;
}

const ProductsPageContent: React.FC<ProductsPageContentProps> = ({
  breadcrumbMenu,
  className = '',
  products = [],
  menuCategories = [],
  paginationInfo,
  manufacturers = [],
  sortBy,
  selectedOptions,
  selectedManufacturer,
  priceRange,
  categoryId,
  handleSortChange,
  handleOptionsChange,
  handleFilterChange,
  handlePageChange
}) => {
  // Estados para filtros básicos
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');

  // Usar productos de PrestaShop directamente (ya vienen como ProductCard)
  const productsToUse = products;
  // Usar el hook para opciones de ordenamiento
  const { sortOptions, getCurrentSortLabel } = useSortOptions();

  // Usar el hook para opciones de filtro
  const { filterOptions } = useFilterOptions();

  const handleSortClick = (sortValue: string) => {
    handleSortChange(sortValue);
  };


  // Función para manejar clics en chips de filtro
  const handleChipFilterClick = useCallback((filterValue: string) => {
    handleOptionsChange(filterValue);
  }, [handleOptionsChange]);

  const handleFilterClick = (manufacturer?: number, price_min?: number, price_max?: number) => {
    handleFilterChange(manufacturer, price_min, price_max);
  }; 



  const toggleViewMode = () => {
    const newViewMode = viewMode === 'grid' ? 'list' : 'grid';
    setViewMode(newViewMode);
  };

  const handleToggleFavorite = (productId: string) => {
    // Manejar favoritos aquí
  };

  const finalProducts = productsToUse;

  return (
    <div data-component-id="src/components/sections/ProductsPageContent.tsx:90:4" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="90" data-component-file="ProductsPageContent.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${className}`}>
      <div data-component-id="src/components/sections/ProductsPageContent.tsx:91:6" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="91" data-component-file="ProductsPageContent.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-global-10%20rounded-%5B20px%5D%20mx-4%20mt-2%22%7D" className="bg-global-10 rounded-[20px] mx-4 mt-2">
        <ProductsFilterBar data-component-id="src/components/sections/ProductsPageContent.tsx:92:8" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="92" data-component-file="ProductsPageContent.tsx" data-component-name="ProductsFilterBar" data-component-content="%7B%22elementName%22%3A%22ProductsFilterBar%22%7D"
          selectedFilters={selectedOptions}
          onChipClick={handleChipFilterClick}
          sortBy={sortBy}
          onSortChange={handleSortClick}
          showSortDropdown={showSortDropdown}
          onToggleSortDropdown={() => setShowSortDropdown(!showSortDropdown)}
          viewMode={viewMode}
          onToggleViewMode={toggleViewMode}
          sortOptions={sortOptions}
          getCurrentSortLabel={() => getCurrentSortLabel(sortBy)}
          filterOptions={filterOptions}
        />
        <div data-component-id="src/components/sections/ProductsPageContent.tsx:105:8" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="105" data-component-file="ProductsPageContent.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-row%22%7D" className="flex flex-row">
          {/* Sidebar con carga de categorías */}
          <CategoriesSidebar data-component-id="src/components/sections/ProductsPageContent.tsx:107:10" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="107" data-component-file="ProductsPageContent.tsx" data-component-name="CategoriesSidebar" data-component-content="%7B%22elementName%22%3A%22CategoriesSidebar%22%7D"
                categories={menuCategories}
                breadcrumbMenu={breadcrumbMenu}
                loading={false}
                error={null}
                onFilterChange={handleFilterClick}
                manufacturers={manufacturers}
                selectManufacturer={selectedManufacturer}
                selectPriceRange={priceRange}
              />
          {/* Main Content */}
          <div data-component-id="src/components/sections/ProductsPageContent.tsx:118:10" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="118" data-component-file="ProductsPageContent.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%20p-6%22%7D" className="flex-1 p-6">
              <ProductsGrid data-component-id="src/components/sections/ProductsPageContent.tsx:119:14" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="119" data-component-file="ProductsPageContent.tsx" data-component-name="ProductsGrid" data-component-content="%7B%22elementName%22%3A%22ProductsGrid%22%2C%22className%22%3A%22w-full%22%7D"
                breadcrumbMenu={breadcrumbMenu}
                products={finalProducts}
                viewMode={viewMode}
                onToggleFavorite={handleToggleFavorite}
                className="w-full"
              />
          </div>
        </div>

        {/* Paginación */}
        {paginationInfo && (
          <div data-component-id="src/components/sections/ProductsPageContent.tsx:131:10" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="131" data-component-file="ProductsPageContent.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-8%20mb-6%22%7D" className="mt-8 mb-6">
            <Pagination data-component-id="src/components/sections/ProductsPageContent.tsx:132:12" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="132" data-component-file="ProductsPageContent.tsx" data-component-name="Pagination" data-component-content="%7B%22elementName%22%3A%22Pagination%22%2C%22className%22%3A%22%22%7D"
              paginationInfo={paginationInfo}
              handlePageChange={handlePageChange}
              className=""
            />
          </div>
        )}
      </div>
      <div data-component-id="src/components/sections/ProductsPageContent.tsx:140:6" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="140" data-component-file="ProductsPageContent.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-6%20mb-12%22%7D" className="mt-6 mb-12">
        {(() => {
          // Usar la categoría más específica disponible (nivel 3, luego 2, luego 1)
          const categoryId = breadcrumbMenu.menuLevel3?.id || 
                            breadcrumbMenu.menuLevel2?.id || 
                            breadcrumbMenu.menuLevel1?.id;
          return categoryId ? (
            <AboutSectionCategories data-component-id="src/components/sections/ProductsPageContent.tsx:147:12" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="147" data-component-file="ProductsPageContent.tsx" data-component-name="AboutSectionCategories" data-component-content="%7B%22elementName%22%3A%22AboutSectionCategories%22%7D" categoryId={categoryId} />
          ) : (
            <AboutSection data-component-id="src/components/sections/ProductsPageContent.tsx:149:12" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="149" data-component-file="ProductsPageContent.tsx" data-component-name="AboutSection" data-component-content="%7B%22elementName%22%3A%22AboutSection%22%7D" />
          );
        })()}
      </div>
      <div data-component-id="src/components/sections/ProductsPageContent.tsx:153:6" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="153" data-component-file="ProductsPageContent.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-12%22%7D" className="mb-12">
        {(() => {
          // Usar la categoría más específica disponible (nivel 3, luego 2, luego 1)
          const categoryId = breadcrumbMenu.menuLevel3?.id || 
                            breadcrumbMenu.menuLevel2?.id || 
                            breadcrumbMenu.menuLevel1?.id;
          return categoryId ? (
            <FAQSectionCategories data-component-id="src/components/sections/ProductsPageContent.tsx:160:12" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="160" data-component-file="ProductsPageContent.tsx" data-component-name="FAQSectionCategories" data-component-content="%7B%22elementName%22%3A%22FAQSectionCategories%22%7D" categoryId={categoryId} />
          ) : (
            <FAQSection data-component-id="src/components/sections/ProductsPageContent.tsx:162:12" data-component-path="src/components/sections/ProductsPageContent.tsx" data-component-line="162" data-component-file="ProductsPageContent.tsx" data-component-name="FAQSection" data-component-content="%7B%22elementName%22%3A%22FAQSection%22%7D" />
          );
        })()}
      </div>
    </div>
  );
  };

export default ProductsPageContent; 